import React from 'react'
import HomeApp from '../../features/home/Home'
export default function Home() {
  return (<HomeApp/> )
}
